import { Link } from 'react-router-dom';
import './MenuTabs.scss';

const MenuTabs = ({ menuList, resolvedActiveIdx, pathname, queryParamKey }) => {
  return (
    <div className="menuTabs">
      <div className="menuTabsContainer">
        {menuList.map((menu, idx) => {
          const isActive = idx === resolvedActiveIdx;
          return (
            <Link
              key={menu.tags}
              className={`menuTabsItem ${isActive ? 'active' : ''}`}
              to={{
                pathname: pathname,
                search: `?${queryParamKey}=${menu.tags}`,
              }}
            >
              {menu.name}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

export default MenuTabs;
